import { wrapper } from './wrapper';


export function wrapperRouter(target) {
    return class extends target {
      constructor(...args) {
          let {routes} = args[0]
          routes = wrapper.routes(routes)
          super(...args);
      }
    }
  }
